import {
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  Hidden,
  IconButton,
  Paper,
  Typography
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close';
import { useGetSessionQuery } from '../services/api';
import RelatedSessions from "./RelatedSessions";
import { SessionDialogActions } from './SessionDialogActions';
import { SessionDialogDetails } from './SessionDialogDetails';
import { SessionSchedule } from './SessionSchedule';
import { useIsInSession } from '../isInSession';

const SessionDialog = ({
  guid,
  onClose,
  showRelated,
}: {
  guid?: string
  onClose: () => void
  showRelated?: boolean
}) => {
  const { data: session, isLoading } = useGetSessionQuery(guid);
  const inSession = useIsInSession(session)
  return (
    <Dialog
      onClose={onClose}
      open={!!guid}
      maxWidth='md'
      PaperProps={{
        style: {
          backgroundColor: '#a0b1af'
        }
      }}
    >
      <DialogTitle>
        <Typography
          fontSize={22}
        >Session Detail</Typography>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Paper
          elevation={0}
          style={{
            padding: 26
          }}
        >
          {isLoading
            ? <CircularProgress />
            : <>
              <Typography
                fontSize={24}
                gutterBottom
              >{session?.title}</Typography>
              <Grid
                container
              >
                <SessionSchedule
                  guid={guid}
                />
                <Grid
                  container
                  display='flex'
                  flexDirection='row'
                  item
                  marginTop={4}
                  xs={12}
                >
                  <>
                    <Hidden mdUp>
                      <SessionDialogActions
                        guid={guid}
                        inSession={inSession}
                      />
                    </Hidden>
                    <SessionDialogDetails
                      guid={guid}
                    />
                    <Hidden mdDown>
                      <SessionDialogActions
                        guid={guid}
                        inSession={inSession}
                      />
                    </Hidden>
                    {showRelated &&
                      <Grid
                        item
                        sx={{
                          marginTop: 1
                        }}
                        xs={12}
                      >
                        <Typography
                          fontWeight={500}
                        >Related Sessions</Typography>
                        <br />
                        <RelatedSessions
                          guid={guid}
                        />
                      </Grid>
                    }
                  </>
                </Grid>
              </Grid>
            </>
          }
        </Paper>
      </DialogContent>
    </Dialog>
  )
}

function SessionDialogWrapper({
  guid,
  onClose,
  showRelated,
}: {
  guid?: string
  onClose: () => void
  showRelated?: boolean
}) {
  if (!guid)
    return null;

  return (
    <SessionDialog
      guid={guid}
      onClose={onClose}
      showRelated={showRelated}
    />
  )
};

export default SessionDialogWrapper;